<template>
  <div class="single-PDF-upload">
    <Uploader
      v-if="vipRight.bookSize"
      ref="uploader"
      id="singleUploader"
      :dropzoneOptions="singleDropzoneOptions"
      @uploadProgress="uploadProgress"
      @addFile="addFile"
      @uploadSuccess="uploadSuccess"
      @uploadError="uploadError"
      @canceled="uploadCanceled"
      @uploadComplete="uploadComplete"
      @uploadSending="uploadSending"
    >
      <div class="button-upload"></div>
    </Uploader>
  </div>
</template>

<script>
import apis from '@api/login'
import Uploader from '@components/common/Uploader'
import { isIllegalWord } from '@/utils'
import { setEncryption } from '@/utils'
import { mapState } from 'vuex'
import statistics from '@components/books/statistics'

export default {
  name: 'singlePDFUpload',
  mixins: [statistics],
  data() {
    return {
      uploadState: 'ready'
    }
  },
  props: {
    pdfType: {
      type: String,
      default: function() {
        return 'book'
      }
    },
    paperType: {
      type: String
    }
  },
  computed: {
    ...mapState('config', {
      open: (state) => state.bookObj.open,
      dpi: (state) => state.bookObj.dpi,
      referer: (state) => state.bookObj.referer,
      displayPageNo: (state) => state.bookObj.displayPageNo
    }),
    paperStyle() {
      return this.$store.state.config.paperStyle
    },
    ...mapState('common', ['vipRight']),
    singleDropzoneOptions: {
      get() {
        const uploadBaseUrl = process.env.NODE_ENV === 'development' ? location.origin : window.PROJECT_CONFIG.BASE_URL
        let options = {
          url: this.pdfType === 'paper' ? uploadBaseUrl + '/cloudR/epaper/oeUploadParse' : uploadBaseUrl + '/cloudR/ebook/sliceUpload',
          thumbnailWidth: 150,
          maxFiles: 1,
          maxFilesize: this.vipRight.bookSize,
          headers: { Accept: 'application/json, text/plain, */*' },
          autoProcessQueue: false,
          chunking: true,
          chunkSize: 1024 * 1024,
          forceChunking: true,
          acceptedFiles: '.pdf,.PDF',
          duplicateCheck: true,
          timeout: 10000000000000000
        }
        return options
      }
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  methods: {
    upload() {
      const browser = this.getBrowser()
      if (browser === 'QQ浏览器' || browser === 'Safari') {
        //qq浏览器 safari
        if (this.userName) {
          $('#singleUploader').click()
        } else {
          this.login()
        }
      } else {
        this.login()
      }
    },
    login() {
      apis.login().then((res) => {
        if (res && res.data && res.status === 200) {
          let data = res.data
          if (data.code === 101) {
            window.location.href = data.data
          } else {
            //QQ浏览器内不生效
            document.querySelector('#singleUploader').click()
          }
        }
      })
    },
    addFile(file) {
      if (!isIllegalWord(file.name)) {
        this.$nextTick(() => {
          this.$refs.uploader.processQueue()
          this.$emit('updateState', 'singleUploading')
        })
      } else {
        this.$refs.uploader.cancelUpload()
        this.$alert('文件名中含有特殊字符，请重新上传', '提示', {
          confirmButtonText: '确定'
        })
      }
    },
    uploadSending(file, xhr, formData) {
      formData.append('fileName', file.name)
      formData.append('dpi', this.dpi)
      formData.append('open', this.open)
      formData.append('referer', this.referer)
      formData.append('displayPageNo', this.displayPageNo)
      if (this.pdfType === 'paper') {
        formData.append('baozhiId', this.paperType)
      }
      console.log('sending', file, xhr, formData)
    },
    uploadSuccess(file, response) {
      console.log('success', file, response)
      if (file.xhr.response) {
        let res = JSON.parse(file.xhr.response)
        if (res.data) {
          this.$emit('updateProgress', 100)
          let id = res.data.id
          this.$store.commit('config/UPDATE_BOOK_ID', id)
          const encryption_id = setEncryption(id)
          setTimeout(() => {
            if (this.pdfType === 'paper') {
              this.$router.push({ path: '/paper', query: { id: encryption_id } })
            } else {
              this.$router.push({ path: '/book', query: { id: encryption_id } })
            }
            this.$store.commit('config/UPDATE_BOOK_ID', id)
            this.$store.commit('book/UPDATE_ISSHOWWINDOW', 2)
            this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'editContent')
            this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', true)
          }, 300)

          //上传成功后，会恢复参数设置到默认状态
          this.$store.commit('config/UPDATE_ADDITIONAL_SETTING', { dpi: '180', open: 0, referer: 1, displayPageNo: this.displayPageNo })
        } else {
          if (res.message && res.message.includes('请进行空间扩容')) {
            // this.$refs.spaceDialog.visible = true
            this.$emit('toSpace', 'single')
          } else {
            this.$alert(res.message || '上传失败', '提示', {
              confirmButtonText: '确定',
              callback: (action) => {
                if (action === 'confirm') {
                  this.$refs.uploader.cancelUpload()
                  this.$nextTick(() => {
                    this.uploadCanceled()
                  })
                }
              }
            })
          }
        }
      }
    },
    uploadComplete(file) {
      console.log('uploadComplete', file)
    },
    uploadError(file, message, xhr) {
      console.log('error', file, message, xhr)
      // uploaderror Server responded with 0 code.
      // Upload canceled.

      if (message.startsWith('File is too big')) {
        this.$alert(`上传PDF文件大于${this.vipRight.bookSize}M，请重新上传`, '提示', {
          confirmButtonText: '确定'
        })
      } else if (message.startsWith("You can't upload files of this type")) {
        this.$alert('请上传pdf文件', '提示', {
          confirmButtonText: '确定'
        })
      } else if (message !== 'Upload canceled.') {
        this.$alert(`您的作品内容较多，不能短时间内完成转换，请耐心等待，返回我的${this.pdfType === 'paper' ? '数字报' : '书刊'}列表稍后刷新查看`, '提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.push({ name: 'list', params: { to: this.pdfType } })
          }
        })
      }
      this.$nextTick(() => {
        this.uploadCanceled()
      })
    },
    uploadProgress(file, progress, bytesSent) {
      const percentage = Number(((bytesSent / file.size) * 100).toFixed(2))
      this.$emit('updateProgress', percentage)
    },
    uploadCanceled(file) {
      console.log('cancel', file)
      this.$emit('updateState', 'ready')
      this.$emit('updateProgress', 0)
    },
    cancelRestore() {
      this.$refs.uploader.cancelUpload()
      this.$nextTick(() => {
        this.uploadCanceled()
      })
    }
  },
  components: {
    Uploader
  }
}
</script>

<style lang="scss" scoped>
.vue-dropzone {
  height: 100%;
  width: 100%;
  min-height: 40px !important;
  border: 0;
  padding: 0;
  position: absolute;
  &:hover {
    background: #fff;
  }
  .dz-message {
    margin: 0;
  }
}
</style>
